/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Nav_LabelInputs */

const en_how_we_work_nav_label = /** @type {(inputs: How_We_Work_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Engagement stages`)
};

const lv_how_we_work_nav_label = /** @type {(inputs: How_We_Work_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sadarbības posmi`)
};

/**
* | output |
* | --- |
* | "Engagement stages" |
*
* @param {How_We_Work_Nav_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_nav_label = /** @type {((inputs?: How_We_Work_Nav_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Nav_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_nav_label(inputs)
	return en_how_we_work_nav_label(inputs)
});